import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import MotifFormField from '@ey/motif-react-wrapper/FormField';
import MotifToggleSwitch from '@ey/motif-react-wrapper/ToggleSwitch';
import MotifSearch from '@ey/motif-react-wrapper/Search';
import MotifButton from '@ey/motif-react-wrapper/Button';
import styled from 'styled-components';
import Pagination from '../../../Common/Pagination/PaginationMotif';
import Loader from '../../../Common/Loaders/loadingindicator';
import Toast from '../../../Common/Toast/Toast';
import ModalControl from '../../../Common/Modal/Modal';
import {
	pagingOptions,
	successMessageDisplayDuration,
	UserLookupType,
	reportFormateType
} from '../../../../util/uiconstants';
import {labels, currentResource} from '../../../../util/uiconstants';
import env from '../../../../util/env';
import {downloadReport} from '../../../../actions/admin/reportaction';
import * as manageaccessactions from '../../../../actions/admin/manageaccessactions';
import {setIsModalOpen} from '../../../../actions/modalstateactions';
import {clearErrors} from '../../../../actions/erroractions';

import AdminUserItemList from './adminuseritemlist';
import AddUser from '../../../Common/AddUser/AddUser';
import DeactivateUser from './deactivateuser';
import AccessDeniedMessage from '../../../Common/AccessDeniedMessage/AccessDeniedMessage';
import {getMeCall} from '../../../../actions/admin/mepermissionsactions';
import {getLocalizedAPIError} from '../../common/util';
import {MotifIcon} from '@ey-xd/motif-react';
import {IconoirPlusCircle} from '@ey-xd/motif-icon';

function ManageAccess() {
	// hooks
	const adminUser = useSelector((store) => store.adminUsers);
	const userPermissions = useSelector((store) => store.userPermissions);
	const dispatch = useDispatch();
	const history = useHistory();

	//states
	const [searchInputValue, setSearchInputValue] = useState('');
	const [page, setPage] = useState(1);
	const [totalPages, setTotalPages] = useState(0);
	const [optionPerPage, setOptionPerPage] = useState(pagingOptions.options[0]);
	const [showInactive, setShowInactive] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [showAddUser, setShowAddUser] = useState(false);
	const [showDeactivateUserModal, setShowDeactivateUserModal] = useState(false);
	const [isMeCallSent, setIsMeCallSent] = useState(false);
	const [userToDeactivate, setUserToDeactivate] = useState();
	const [addUserSuccessMessage, setAddUserSuccessMessage] = useState('');
	const [isErrorOccurred, setIsErrorOccurred] = useState(false);
	const duration = successMessageDisplayDuration;
	const [addUserErrorMessage, setAddUserErrorMessage] = useState([]);
	const [addUserLoading, setAddUserLoading] = useState(false);

	useEffect(() => {
		dispatch(getMeCall()).then(() => setIsMeCallSent(true));
	}, []);

	useEffect(() => {
		if (isMeCallSent && userHasManageAccessPerm()) {
			loadAdminUsers(searchInputValue);
		}
	}, [showInactive, page, optionPerPage, userPermissions, isMeCallSent]);

	useEffect(() => {
		if (adminUser) {
			setTotalPages(adminUser.pages);
		}
	}, [adminUser]);

	useEffect(() => {
		if (showAddUser == true) {
			dispatch(clearErrors()).then(function () {
				dispatch(setIsModalOpen(true));
			});
		} else {
			dispatch(clearErrors());
			dispatch(setIsModalOpen(false));
		}
	}, [showAddUser]);

	useEffect(() => {
		const timer = setTimeout(() => {
			setAddUserSuccessMessage('');
		}, duration);
		return () => clearTimeout(timer);
	});

	const loadAdminUsers = (searchText) => {
		setIsLoading(true);
		let adminUserUrl =
			env.getURL('serviceUrlV2') +
			`admin/Users?page=${page}&pageSize=${optionPerPage}&isActive=${!showInactive}`;

		if (searchText) {
			adminUserUrl += `&searchString=${encodeURIComponent(searchText)}`;
		}

		dispatch(manageaccessactions.getAdminUsers(adminUserUrl))
			.then(() => {
				setIsLoading(false);
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	const onSearchChange = () => {
		if (searchInputValue != undefined) {
			setPage(1);
			loadAdminUsers(searchInputValue);
		}
	};

	const onClearClick = () => {
		setSearchInputValue('');
		loadAdminUsers('');
	};

	const paginationHandler = (value) => {
		if (page !== value && page > 0) {
			setPage(value);
		}
	};
	const handlerOptionPage = (value) => {
		if (value !== optionPerPage) {
			setOptionPerPage(value);
			setPage(1);
		}
	};

	const saveUsers = (selectedUsers, ticketNumber) => {
		if (selectedUsers?.length <= 0) {
			return;
		}
		setAddUserLoading(true);
		let data = {
			ticketNumber: ticketNumber,
			userModel: selectedUsers
		};

		let adminUserUrl = env.getURL('serviceUrlV2') + `admin/Users`;

		dispatch(manageaccessactions.addAdminUsers(adminUserUrl, data))
			.then(() => {
				setAddUserLoading(false);
				setAddUserSuccessMessage(labels.addUserSuccessMessage);
				closeAddUserModal(true);
			})
			.catch((result) => {
				setIsErrorOccurred(true);
				setAddUserErrorMessage([getLocalizedAPIError(result)]);
			})
			.finally(() => {
				setAddUserLoading(false);
			});
	};

	const downloadUserAccessReport = () => {
		setIsLoading(true);
		var url = env.getURL('serviceUrlV2') + 'admin/reports/useraccessreport';
		dispatch(
			downloadReport(url, 'User-Access-Report.' + reportFormateType.xlsx)
		).finally(() => {
			setIsLoading(false);
		});
	};

	/*** Add User Modal functions starts***/
	useEffect(() => {
		if (history.location.hash.toLowerCase() == '#addnewuser') {
			setShowAddUser(true);
		}
	}, [history.location]);

	useEffect(() => {
		if (userToDeactivate) {
			setShowDeactivateUserModal(true);
		}
	}, [userToDeactivate]);

	const openAddUserModal = () => {
		history.push({
			pathname: history.location.pathname,
			hash: 'addnewuser'
		});

		setShowAddUser(!showAddUser);
	};

	const closeAddUserModal = (shallRefresh) => {
		setShowAddUser(false);
		setAddUserErrorMessage([]);
		if (history.location.hash && history.location.hash.length > 0) {
			history.replace({
				pathname: history.location.pathname,
				search: history.location.search,
				hash: ''
			});
		}
		if (shallRefresh) {
			loadAdminUsers(searchInputValue);
		}
	};

	const closeDeactivateUserModal = (shallRefresh) => {
		setShowDeactivateUserModal(false);
		setUserToDeactivate(undefined);

		if (shallRefresh) {
			loadAdminUsers(searchInputValue);
		}
	};

	const onDeactivateUserClick = (user) => {
		setUserToDeactivate(user);
	};

	const userHasManageAccessPerm = () =>
		userPermissions?.permissions &&
		(userPermissions.permissions.canCreateUpdateManageAccess ||
			userPermissions.permissions.canReadManageAccess);
	/*** Add User Modal functions ends ***/

	return !userHasManageAccessPerm() ? (
		<AccessDeniedMessage permissionMesage={labels.insufficientPermission} />
	) : (
		<Mainwrapper>
			<section className="manageaccess mainResponsiveWrapper">
				<section
					className={
						'toastMessage ' +
						(addUserSuccessMessage.length > 0 ? 'block' : 'none')
					}
				>
					<Toast
						variant="success"
						duration={duration}
						onClose={() => setAddUserSuccessMessage('')}
					>
						{addUserSuccessMessage}
					</Toast>
				</section>
				<section className="add-on">
					<section className="search">
						<MotifFormField>
							<MotifSearch
								placeholder={labels.searchUserText}
								value={searchInputValue}
								onChange={(e) => setSearchInputValue(e.target.value)}
								onSearchButtonClick={onSearchChange}
								onClear={onClearClick}
								onEnter={onSearchChange}
								clearHoverText={labels.clear}
							/>
						</MotifFormField>
					</section>
					<section className="showinactive">
						<MotifToggleSwitch
							aria-describedby="showuser"
							checked={showInactive}
							onChange={(event) => {
								setShowInactive(event.target.checked);
								setPage(1);
							}}
							id="toggle1"
							offLabel=""
							onLabel={labels.showInactiveUserslabel}
						/>
					</section>

					<section className="downloadReport">
						<a onClick={downloadUserAccessReport}>{labels.generateReport}</a>
					</section>

					<section className="adduser">
						<MotifButton
							aria-label="Add user"
							variant="text-alt"
							disabled={false}
							onClick={() => {
								openAddUserModal();
							}}
						>
							<MotifIcon
								className="icon-container"
								src={IconoirPlusCircle}
								size="20"
							/>
							{labels.addUserButtonLabel}
						</MotifButton>
					</section>
				</section>
			</section>

			{isLoading ? (
				<Loader show view="blockView" styleName="loadingstyle" />
			) : adminUser?.totalEntityCount > 0 ? (
				<AdminUserItemList
					data={adminUser?.data}
					onDeactivate={onDeactivateUserClick}
				/>
			) : (
				<section className="manageaccess noresult">
					{labels.noResultsFound}
				</section>
			)}

			{!isLoading && (
				<section className="pagerholder">
					<Pagination
						styleName="manageaccess-paging mainResponsiveWrapper"
						options={pagingOptions.options}
						pageSize={optionPerPage}
						showText={currentResource.common.pagination.show}
						onPageSizeChange={(pageSize) => {
							handlerOptionPage(pageSize);
						}}
						totalPages={totalPages}
						currentPage={page}
						onPageChange={(pageNumber) => {
							paginationHandler(pageNumber);
						}}
					/>
				</section>
			)}
			<ModalControl
				className="adduser-modal"
				title={labels.addUser}
				onOkClick={() => {}}
				onHide={() => closeAddUserModal(false)}
				isOkButtonDisabled={false}
				show={showAddUser}
				modalsize="small"
				showButtons={false}
				closeTitle={labels.close}
				role="dialog"
				focusTrapActive={false}
			>
				<AddUser
					onNewUserModalClose={closeAddUserModal}
					addUserErrorMessage={addUserErrorMessage}
					userLookupType={UserLookupType.Admin}
					onSaveUsersClick={saveUsers}
					addUserLoading={addUserLoading}
					addUserDescription={labels.addAdminUserHeader}
				/>
			</ModalControl>
			<ModalControl
				className="deactivate-user-modal"
				title={labels.deactivateModalTitle}
				onOkClick={() => {}}
				onHide={() => closeDeactivateUserModal(false)}
				isOkButtonDisabled={false}
				show={showDeactivateUserModal}
				modalsize="x-small-secondary"
				showButtons={false}
				closeTitle={labels.close}
				role="dialog"
				focusTrapActive={false}
			>
				<DeactivateUser
					userToDeactivate={userToDeactivate}
					onDeactivateModalClose={closeDeactivateUserModal}
				/>
			</ModalControl>
		</Mainwrapper>
	);
}

const Mainwrapper = styled.section`
	padding-top: var(--spacing-xx-large);
	.downloadReport {
		a {
			font-size: var(--px-14);
			font-weight: 400;
			cursor: pointer;
			color: var(--blue-600);
			margin: 0 var(--spacing-large);
			&:hover {
				text-decoration: none;
			}
		}
	}

	.loadingstyle {
		height: calc(100vh - var(--px-280)) !important;
	}

	//heading
	.manageaccess {
		.toastMessage {
			&.block {
				display: block;
			}

			&.none {
				display: none;
			}
		}

		.pageheading {
			display: flex;
			padding: var(--px-20) 0;
			svg {
				min-width: var(--px-25) !important;
				min-height: var(--px-25) !important;
				margin-right: var(--px-10);
			}

			h3 {
				margin: 0;
				line-height: var(--px-25);
			}
		}
	}

	//noresult
	.noresult {
		height: calc(100vh - var(--px-300));
		justify-content: center;
		align-items: center;
		display: flex;
		font-size: var(--px-14);
		color: var(--neutrals-700);
	}

	//addon

	.add-on {
		display: flex;
		margin-right: auto;
		align-items: end;
		padding-bottom: var(--spacing-x-large);
		.adduser {
			display: flex;
			align-items: end;
		}

		.search {
			width: var(--px-400);
			margin-right: auto;
		}
	}

	//inactive user
	.showinactive {
		display: flex;
	}

	//pagination

	.pagerholder {
		width: calc(100vw - var(--px-80));
		margin: 0 auto;
		max-width: 2048px;
		display: flex;
		padding: var(--spacing-x-large) 0;
	}

	.manageaccess-paging {
		justify-content: flex-end;
		line-height: normal;
		min-width: auto !important;
		font-size: var(--px-14);
	}

	.userlistitem.contextmenu .context {
		cursor: pointer;
	}
`;

export default ManageAccess;
